import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FiCamera } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

import { Spinner } from '@mssgme/ui';
import styles from './ImagePreview.scss';

export default function ImagePreview({ className, url, width, height, roundness, hasTip, isUploading }) {
    const { t } = useTranslation();
    const style = {
        width: `${width}px`,
        height: `${height}px`,
    };

    if (url) {
        style.backgroundImage = `url("${url}")`;
    }

    return (
        <div
            className={classNames(className, [styles.root], styles[roundness], isUploading && styles.uploading)}
            style={style}
        >
            {!url && hasTip && (
                <div className={styles.emptyTip}>
                    <FiCamera size="24" />
                    <span>{t('imagePreview.placeholder')}</span>
                </div>
            )}

            {isUploading && (
                <div className={styles.spinner}>
                    <Spinner />
                </div>
            )}
        </div>
    );
}

ImagePreview.propTypes = {
    className: PropTypes.string,
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    roundness: PropTypes.oneOf(['circle', 'rounded']),
    hasTip: PropTypes.bool,
    isUploading: PropTypes.bool,
};

ImagePreview.defaultProps = {
    width: 40,
    height: 40,
    roundness: 'circle',
};
